import { render, staticRenderFns } from "./page-footModule.vue?vue&type=template&id=45e1220e&scoped=true"
import script from "./page-footModule.vue?vue&type=script&lang=js"
export * from "./page-footModule.vue?vue&type=script&lang=js"
import style0 from "./page-footModule.vue?vue&type=style&index=0&id=45e1220e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1220e",
  null
  
)

export default component.exports